import type { FieldMeta } from './types';

/**
 * 按引用（字段 id 或名称）在字段列表里找字段。内置模板用「字段名」绑定，
 * 换到不同表时靠名称模糊匹配自动适配：精确 id → 精确名 → 去空归一 →
 * 包含。渲染与取数两处共用，保证一致。
 */
export function findFieldByRef(
  fieldMetas: Pick<FieldMeta, 'id' | 'name'>[],
  ref: string,
): Pick<FieldMeta, 'id' | 'name'> | undefined {
  if (!ref) return undefined;
  const byId = fieldMetas.find((m) => m.id === ref);
  if (byId) return byId;
  const byName = fieldMetas.find((m) => m.name === ref);
  if (byName) return byName;
  const norm = (s: string) => s.replace(/\s+/g, '').toLowerCase();
  const nref = norm(ref);
  const byNorm = fieldMetas.find((m) => norm(m.name) === nref);
  if (byNorm) return byNorm;
  // 包含（字段名含引用词，或引用词含字段名），取最短名以求最精确
  const contains = fieldMetas
    .filter((m) => {
      const nm = norm(m.name);
      return nm.includes(nref) || nref.includes(nm);
    })
    .sort((a, b) => a.name.length - b.name.length);
  return contains[0];
}
